import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import { ApiAccounts } from '../api/apiAccounts';
import { Account, defaultAccount } from '../types/account';

export const accountInfoVersionAtom = atom(0);
const accountInfoAtom = atom(async (get) => {
  get(accountInfoVersionAtom);

  const value = await ApiAccounts.get();
  const accountInfo: Account = { ...defaultAccount, ...value };

  return accountInfo;
});

export const loadableAccountInfoAtom = loadable(accountInfoAtom);
